import React from 'react'

import { Tab, Tabs } from './styled'

export default function MarketTabs({ activeTab, onTabChange, t }) {
  return (
    <Tabs role="tablist" aria-label={t('competitive_intelligence_market_tabs')}>
      {['events', 'news', 'social'].map(tab => (
        <Tab
          key={tab}
          type="button"
          role="tab"
          active={activeTab === tab}
          aria-selected={activeTab === tab}
          onClick={() => onTabChange(tab)}
        >
          {t(`competitive_intelligence_market_tab_${tab}`)}
        </Tab>
      ))}
    </Tabs>
  )
}
